<script>
  import Badge from "../../../atoms/Badge.svelte";

  let { status } = $props();
  const mapping = {
    trial: "TRIAL",
    trialEnded: "TRIAL EXPIRED",
  };
  let text = $derived(mapping[status]);
</script>

<Badge value={text} position="center" inline type="trial" />
